import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=874e69f2"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports